import React, { useEffect, useState } from 'react'
import { IoMapOutline } from 'react-icons/all'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Text } from '../'
import { Container, ButtonOpenMap, TextRight, Titles} from './index.styled'
import { setMenu, setMenuContent, setCurrentMap } from './../../effects/actions'
const menuMap = require('../../assets/mock-data/menu-map.json')

const OpenMapMobile = React.memo(({ setMenu, setMenuContent, currentMap = null, setCurrentMap }) => {
  const [map, setMap] = useState(null)
  
  useEffect(() => {
    if (!currentMap) return;
    const temp = menuMap.find((x) => x.items?.length > 0
      ? x.items.find(y => y.id === currentMap)
      : x.id === currentMap);
    setMap(temp);
  }, [currentMap])

  const handleMenu = () => {
    console.log("entra aqui 4")
    setMenu(true);
    setMenuContent('map');
    setCurrentMap(currentMap);
  }
  const title = (map?.items?.length > 0 ? map.items.find(x => x.id === currentMap)?.title : map?.title)

  return (
    <Container>
      <ButtonOpenMap onClick={() => handleMenu()}>
        <TextRight><FormattedMessage id="open-map" /></TextRight>
        <IoMapOutline />
      </ButtonOpenMap>
      <Titles>
        <Text
          color="#FFF"
          textTransfor="normal"
          fontFamily="Amorim Sans Book"
          fontSizeMobile='16px'
          fontSize='16px'
          textId={title}
        />
      </Titles>
    </Container>
  )
})

export default connect(null, { setMenu, setMenuContent, setCurrentMap })(React.memo(OpenMapMobile))